import { CrashReporter } from '@utils/crash-reporter'

/**
 * Starts Angular and reports a failed start (a provider or an app initializer throwing, a rejected
 * initializer) as a crash. Angular rejects the bootstrap instead of raising it on the window, so nothing else
 * would ever see it; the guest is left on a blank page.
 */
export const startApp = (
	bootstrap: () => Promise<unknown>,
	reporter: Pick<CrashReporter, 'reportFailedStart' | 'markStarted'>
): Promise<void> =>
	bootstrap().then(
		() => reporter.markStarted(),
		(error: unknown) => {
			console.error(error)
			reporter.reportFailedStart(error)
		}
	)
